import React, { useEffect, useRef, useState } from "react";
import SelectFromLibr from "./SelectFromLibr";
import DefaultQuestion from "./DefaultQuestion";
import QuestionListAssessment from "./QuestionListAssessment";
import axios from "../../axios";
import { useSelector } from "react-redux";
import ProgressBar from "../../Helper/ProgressBar";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import OperationType from "../../Enum/OperationTypeEnum";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { useNavigate } from "react-router-dom";
import PublishPreviewQB from "./PublishPreviewQB";
import CheckDuplicatePop from "./CheckDuplicatePop";
import { toast } from "react-toastify";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { ListChecks, Sparkles, Upload, Search, Trash2 } from "lucide-react";
import { WarningAmber } from "@mui/icons-material";
import { hasFeature } from "../../Utils/features";
import AiGenerateQuestions from "./AiGenerateQuestions";
import QuestionPaperMapper from "./QuestionPaperMaper";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const UpdateQuestions = ({
  operationType,
  componentType,
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
  questions,
  setQuestions,
  addMoreQuestion,
  checkAllDataField,
  findTotalMarks,
  handleCreateAssessment,
  isloading,
  showErrorInputField,
  setShowErrorInputField,
  getErrorMsg,
  isChecked,
  setIsChecked,
  isCheckAdaptiveAdd,
  findDuplicateQuestions,
  handleAdaptiveQuesType,
  viewErrorMsg,
  hidePopupCheck,
  isSetOpenPopupDupli,
  isopenPopupDupli,
  selectedBox,
  copyPrevSettings,
  setCopyPrevSettings,
}) => {
  const [questionTypeData, setQuestionTypeData] = useState([]);
  const [difficultyLevel, setDifficultyLevel] = useState([]);
  const [sourceLibrary, setSourceLibrary] = useState(null);
  const [questionData, setquestionData] = useState([]);
  const [open, setOpen] = useState(false); // 👈 QB preview (PublishPreviewQB)
  const [click, setClick] = useState(false); // 👈 Assessment review (QuestionListAssessment)
  const [newQuestionPaperMaper, setNewQuestionPaperMaper] = useState(false);
  const domainsData = useSelector((state) => state.initialData.domain);
  const [searchTerm, setSearchTerm] = useState("");
  const questionRefs = useRef({});
  const scrollContainerRef = useRef(null);

  // Delete Confirmation State
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  const navigate = useNavigate();
  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;

  const [click1, setClick1] = useState(false);
  const skillsData = useSelector((state) => state.initialData.skills);
  const [questionType, setQuestionType] = useState([]);
  const [openQuestionBox, setOpenQuestionBox] = useState(false);
  const [activeQuestions, setActiveQuestions] = useState([]);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    types: questionType,
    domains: null,
    chapters: null,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;

  const [questionScoreCounter, setQuestionScoreCounter] = useState({
    skills: [],
    questionType: [],
    difficultyLevel: [],
  });

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  // ==========================================
  // 👈 COMPONENT TYPE FLAG
  // ==========================================
  const isQuestionBank = componentType === ComponentType.QUESTION_BANK;

  // ==========================================
  // 👈 MARKS LOGIC — SIRF NON-QB KE LIYE
  // ==========================================
  const maxMarks = isQuestionBank
    ? 0
    : Number(assessmentDetails?.total_marks) || 0;
  const totalMarks = findTotalMarks() || 0;
  const marksDiff = totalMarks - maxMarks;
  const isMarksMismatch =
    !isQuestionBank && maxMarks > 0 && totalMarks !== maxMarks;

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`,
      );
      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (
      assessmentDetails?.standard_id?.id &&
      assessmentDetails?.section_id?.id &&
      assessmentDetails?.subject_id?.id &&
      timeTableSessionId
    ) {
      getDetails();
    }
  }, [
    assessmentDetails?.standard_id?.id,
    assessmentDetails?.section_id?.id,
    assessmentDetails?.subject_id?.id,
    timeTableSessionId,
  ]);

  useEffect(() => {
    setDropdownList((prev) => ({ ...prev, skills: skillsData }));
    setDropdownList((prev) => ({ ...prev, types: questionType }));
    setDropdownList((prev) => ({ ...prev, domains: domainsData }));
    setDropdownList((prev) => ({
      ...prev,
      difficultyLevels: difficulty_levelData,
    }));
  }, [skills, types, domains, difficultyLevels, questionType]);

  const school_id = JSON.parse(localStorage.getItem("schoolId"));

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );
      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  useEffect(() => {
    setInitialDataInCounter();
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.skill_id !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.skills.map((val) => {
            if (val.id == item.skill_id) val["value"] += correctScore;
            return val;
          });
          return { ...prev, skills: current };
        });
      }
      if (item.question_type !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.questionType.map((val) => {
            if (val.id == item.type_id) val["value"] += correctScore;
            return val;
          });
          return { ...prev, questionType: current };
        });
      }
      if (item.difficulty_level !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.difficultyLevel.map((val) => {
            if (val.id == item.difficulty_level) val["value"] += correctScore;
            return val;
          });
          return { ...prev, difficultyLevel: current };
        });
      }
    });
  }, [questions]);

  const setInitialDataInCounter = () => {
    let skills = [];
    skillsData.map((skill) =>
      skills.push({ value: 0, label: skill.name, id: skill.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, skills: skills }));

    let qType = [];
    questionType.map((type) =>
      qType.push({ value: 0, label: type.name, id: type.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, questionType: qType }));
    setQuestionTypeData(qType);

    let dLevel = [];
    difficulty_levelData.map((level) =>
      dLevel.push({ value: 0, label: level.name, id: level.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, difficultyLevel: dLevel }));
    setDifficultyLevel(dLevel);
  };

  useEffect(() => {
    setInitialDataInCounter();
  }, []);

  const getquestiondata = (data) => setquestionData(data);

  const skillToDomainNameMap = {
    Remember: "Factual",
    Understand: "Conceptual",
    Apply: "Conceptual",
    Analyze: "Procedural",
    Evaluate: "Metacognitive",
    Create: "Metacognitive",
    None: "None",
  };

  const domainNameToIdMap = Object.fromEntries(
    Array.isArray(domains) ? domains.map((d) => [d.name, d.id]) : [],
  );

  const skillsWithDomainId =
    Array.isArray(skills) &&
    skills.map((skill) => {
      const domainName = skillToDomainNameMap[skill.name];
      const domainId = domainNameToIdMap[domainName] || null;
      return { ...skill, domain_id: domainId };
    });

  const noneSkill = skillsWithDomainId?.find((skill) => skill.name === "None");
  const noneDifficulty = difficultyLevel?.find((d) => d.label === "None");

  const getBaseQuestionTemplate = () => ({
    standard_id: standard_id ? standard_id.id : null,
    subject_id: subject_id ? subject_id.id : null,
    section_id: section_id ? section_id.id : null,
    book_id: null,
    chapter_id: null,
    question_type: null,
    type_id: null,
    domain_id: null,
    skill_id: null,
    difficulty_level: null,
    title: null,
    correct_score: null,
    is_mandatory: false,
    add_to: null,
    add_to_mock: false,
    attachments: [],
    options: [],
    correct_answers: [],
  });

  const handleMapperSave = (mapperQuestions) => {
    const othersBook = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.find((book) => book?.name?.toLowerCase() === "others");
    const othersChapter = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.flatMap((book) => book.chapterData || [])
      ?.find((chapter) => chapter?.chapterName?.toLowerCase() === "others");

    setQuestions((prev) => {
      const updated = [...prev];
      mapperQuestions.forEach((mq) => {
        const base = getBaseQuestionTemplate();
        const selectedType = types.find((t) => t.id === mq.type_id);

        let question = {
          ...base,
          title: mq.title,
          correct_score: mq.correct_score,
          skill_id: noneSkill?.id ?? null,
          domain_id: noneSkill?.domain_id ?? null,
          difficulty_level: noneDifficulty?.id ?? null,
          book_id: othersBook?.id ?? null,
          chapter_id: othersChapter?.id ?? null,
          type_id: mq.type_id,
          question_type: String(selectedType?.is_manually_graded),
          attachments: Array.isArray(mq.attachments)
            ? mq.attachments.map((att) =>
                typeof att === "string" ? att : att.url,
              )
            : [],
        };

        if (selectedType?.is_manually_graded === false) {
          question.options = Array.from(
            { length: mq.mcqOptionsCount },
            (_, i) => ({
              key: String.fromCharCode(65 + i),
              value: `Option ${String.fromCharCode(65 + i)}`,
            }),
          );
          question.correct_answers = [
            {
              option_key: mq.correct_answer ?? null,
              value:
                mq.correct_answer != null
                  ? `Option ${mq.correct_answer}`
                  : null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
        } else {
          question.options = [];
          question.correct_answers = [
            {
              value: null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
        }
        updated.push(question);
      });
      return updated;
    });
  };

  const isAdaptiveCase =
    selectedBox === "adaptive" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive;
  const getColClass = () => (isAdaptiveCase ? "col-md-6" : "col-md-4");

  // ==========================================
  // 👈 attentionCount — same logic
  // ==========================================
  const attentionCount = (questions || []).filter((q) => {
    const isQuestionLibraryComponent =
      componentType === ComponentType.QUESTION_BANK;
    const skipOptionValidation = isQuestionLibraryComponent
      ? q.question_type === "true"
      : selectedBox === "auto-evaluate" && q.question_type === "true";

    const isMissingBasic =
      !q.title ||
      !q.skill_id ||
      !q.type_id ||
      !q.chapter_id ||
      !q.correct_score ||
      !q.difficulty_level;

    let isMissingOptions = false;
    if (q.type_id && !skipOptionValidation) {
      if (Array.isArray(q.options) && q.options.length > 0) {
        isMissingOptions = q.options.some((opt) => !opt?.key || !opt?.value);
      }
      if (Array.isArray(q.correct_answers)) {
        isMissingOptions =
          isMissingOptions ||
          q.correct_answers.some(
            (ans) =>
              q?.options?.length > 0 &&
              (!ans?.option_key || ans.option_key.trim() === ""),
          );
      }
    }
    return isMissingBasic || isMissingOptions;
  }).length;

  // ==========================================
  // 👈 handleNextClick — QB vs Assessment branching
  // ==========================================
  const handleNextClick = () => {
    // Marks validation sirf non-QB ke liye
    if (!isQuestionBank && maxMarks > 0 && isMarksMismatch) {
      toast.error(
        marksDiff > 0
          ? `Total marks exceeded by ${marksDiff}. Please reduce.`
          : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`,
      );
      return;
    }

    if (attentionCount > 0) {
      toast.error(
        "Some questions are incomplete. Please check 'Need attention' items.",
      );
      return;
    }

    // 👈 QB → PublishPreviewQB, Assessment/Homework → QuestionListAssessment
    if (isQuestionBank) {
      setOpen(true);
    } else {
      setClick(true);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value) {
      setActiveQuestions([]);
      return;
    }
    const questionNumber = parseInt(value);
    if (!isNaN(questionNumber)) {
      const index = questionNumber - 1;
      if (questionRefs.current[index]) scrollToQuestion(index);
      return;
    }
    const lowerValue = value.toLowerCase();
    const foundIndex = questions.findIndex((q) =>
      q?.title?.toLowerCase().includes(lowerValue),
    );
    if (foundIndex !== -1) scrollToQuestion(foundIndex);
  };

  const scrollToQuestion = (index) => {
    setActiveQuestions([index]);
    setTimeout(() => {
      const element = questionRefs.current[index];
      const container = scrollContainerRef.current;
      if (!element || !container) return;
      container.scrollTo({ top: element.offsetTop - 120, behavior: "smooth" });
    }, 100);
  };

  const toggleQuestion = (index) => {
    setActiveQuestions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const handleExpandAll = () => {
    setActiveQuestions(questions.map((_, i) => i));
  };

  const handleCollapseAll = () => {
    setActiveQuestions([]);
  };

  const handleDeleteClick = (index, e) => {
    e.stopPropagation();
    setQuestionToDelete(index);
    setDeleteConfirmOpen(true);
  };

  const confirmDeleteQuestion = () => {
    if (questionToDelete !== null)
      setQuestions((prev) => prev.filter((_, i) => i !== questionToDelete));
    setDeleteConfirmOpen(false);
    setQuestionToDelete(null);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F9FAFB",
        overflow: "hidden",
      }}
    >
      {/* ========================================== */}
      {/* 1. STICKY HEADER 1 */}
      {/* ========================================== */}
      <div
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #E5E7EB",
          padding: "12px 24px",
          zIndex: 10,
          flexShrink: 0,
        }}
      >
        <div className="d-flex align-items-center justify-content-between gap-3 w-100">
          {/* Left */}
          <div
            className="d-flex align-items-center gap-3"
            style={{ flexShrink: 0 }}
          >
            <div
              onClick={() => navigate(-1)}
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#FFF1E6",
                color: "#F28C28",
                fontSize: "18px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              &lt;
            </div>
            <div className="d-flex flex-column" style={{ maxWidth: "250px" }}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#1f2937",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={name}
              >
                {name || "Update Assessment"}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  color: "#6B7280",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {isQuestionBank ? "Question Bank" : "Assessment"} •{" "}
                {subject_id?.name || "Subject"}
              </span>
            </div>
          </div>

          {/* Center: Library Buttons */}
          <div
            className="d-flex flex-wrap gap-2 justify-content-center"
            style={{ flex: 1 }}
          >
            <button
              onClick={() => {
                setClick1(true);
                setSourceLibrary(SourceLibrary.FROM_SCHOOL_LIBRARY);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 14px",
                border: "1px solid #FDE68A",
                borderRadius: "8px",
                backgroundColor: "#FFF7ED",
                color: "#92400E",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FFEDD5";
                e.currentTarget.style.borderColor = "#FCD34D";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFF7ED";
                e.currentTarget.style.borderColor = "#FDE68A";
              }}
            >
              <ListChecks size={16} /> School Bank
            </button>

            <button
              onClick={() => {
                setClick1(true);
                setSourceLibrary(SourceLibrary.FROM_B4S_LIBRARY);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 14px",
                border: "1px solid #FDE68A",
                borderRadius: "8px",
                backgroundColor: "#FFF7ED",
                color: "#92400E",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FFEDD5";
                e.currentTarget.style.borderColor = "#FCD34D";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFF7ED";
                e.currentTarget.style.borderColor = "#FDE68A";
              }}
            >
              <ListChecks size={16} /> B4S Bank
            </button>

            {isQuestionBank && hasFeature("AI_QUERY") && (
              <button
                onClick={() => setOpenQuestionBox(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 14px",
                  border: "1px solid #FDE68A",
                  borderRadius: "8px",
                  backgroundColor: "#FFF7ED",
                  color: "#92400E",
                  fontWeight: 600,
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFEDD5";
                  e.currentTarget.style.borderColor = "#FCD34D";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFF7ED";
                  e.currentTarget.style.borderColor = "#FDE68A";
                }}
              >
                <Sparkles size={16} /> AI Generator
              </button>
            )}

            {!isAdaptiveCase && (
              <button
                onClick={() => setNewQuestionPaperMaper(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 14px",
                  border: "1px solid #FDE68A",
                  borderRadius: "8px",
                  backgroundColor: "#FFF7ED",
                  color: "#92400E",
                  fontWeight: 600,
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFEDD5";
                  e.currentTarget.style.borderColor = "#FCD34D";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFF7ED";
                  e.currentTarget.style.borderColor = "#FDE68A";
                }}
              >
                <Upload size={16} /> Import File
              </button>
            )}
          </div>

          {/* Right: Actions */}
          <div
            className="d-flex gap-2 align-items-center"
            style={{ flexShrink: 0 }}
          >
            <button
              onClick={() => navigate(-1)}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                backgroundColor: "#fff",
                color: "#111827",
                fontWeight: 500,
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              ← Back
            </button>
            <button
              disabled={
                !questions ||
                questions.length === 0 ||
                isMarksMismatch ||
                attentionCount > 0
              }
              onClick={handleNextClick}
              style={{
                padding: "8px 18px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#F28C28",
                color: "#fff",
                fontWeight: 600,
                fontSize: "13px",
                cursor:
                  !questions ||
                  questions.length === 0 ||
                  isMarksMismatch ||
                  attentionCount > 0
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  !questions ||
                  questions.length === 0 ||
                  isMarksMismatch ||
                  attentionCount > 0
                    ? 0.6
                    : 1,
              }}
            >
              Review & Finish
            </button>
          </div>
        </div>
      </div>

      {/* ========================================== */}
      {/* 2. STICKY HEADER 2 (Tray + Stats + Search) */}
      {/* ========================================== */}
      <div
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #E5E7EB",
          padding: "12px 24px",
          zIndex: 9,
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="d-flex align-items-center gap-4">
          <div>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#111827",
                margin: 0,
              }}
            >
              Question Tray
            </h3>
          </div>
          <div
            className="d-flex align-items-center gap-2 bg-light px-3 py-1 rounded-3"
            style={{
              border: "1px solid #E5E7EB",
              fontSize: "13px",
              fontWeight: 600,
              color: "#111827",
            }}
          >
            <span>{questions?.length || 0} Questions</span>
            <span style={{ color: "#9CA3AF" }}>•</span>
            <span>{totalMarks} Marks</span>
            {/* 👈 Marks target sirf non-QB ke liye */}
            {!isQuestionBank && maxMarks > 0 && (
              <Tooltip
                title={
                  isMarksMismatch
                    ? `Target: ${maxMarks} marks`
                    : "Marks match perfectly"
                }
                arrow
              >
                <span
                  style={{
                    color: isMarksMismatch ? "#F28C28" : "#059669",
                    marginLeft: "4px",
                  }}
                >
                  / {maxMarks}
                </span>
              </Tooltip>
            )}
            {attentionCount > 0 && (
              <>
                <span style={{ color: "#9CA3AF" }}>•</span>
                <span style={{ color: "#F28C28", fontSize: "13px" }}>
                  ⚠ {attentionCount} Need attention
                </span>
              </>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center gap-3">
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="search"
              placeholder="Search by Q.No or Title"
              className="search-input form-control rounded-pill ps-4"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                fontSize: "13px",
                padding: "6px 12px 6px 32px",
                height: "34px",
                backgroundColor: "#F9FAFB",
              }}
            />
            <Search
              size={14}
              color="#9CA3AF"
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>

          <div className="d-flex gap-2">
            <button
              type="button"
              onClick={handleCollapseAll}
              style={{
                padding: "6px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: "6px",
                background: "#fff",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              Collapse All
            </button>
            <button
              type="button"
              onClick={handleExpandAll}
              style={{
                padding: "6px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: "6px",
                background: "#fff",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              Expand All
            </button>
          </div>
        </div>
      </div>

      {/* ========================================== */}
      {/* 3. SCROLLABLE MAIN BODY */}
      {/* ========================================== */}
      <div
        ref={scrollContainerRef}
        className="orange-scrollBar"
        style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            paddingBottom: "100px",
          }}
        >
          <div className="d-flex flex-column gap-2">
            {questions && questions.length > 0 ? (
              questions.map((question, index) => {
                const isQuestionLibraryComponent =
                  componentType === ComponentType.QUESTION_BANK;
                const skipOptionValidation = isQuestionLibraryComponent
                  ? question.question_type === "true"
                  : selectedBox === "auto-evaluate" &&
                    question.question_type === "true";

                const isMissingBasic =
                  !question.title ||
                  !question.skill_id ||
                  !question.type_id ||
                  !question.chapter_id ||
                  !question.correct_score ||
                  !question.difficulty_level;

                let isMissingOptions = false;
                if (question.type_id && !skipOptionValidation) {
                  if (
                    Array.isArray(question.options) &&
                    question.options.length > 0
                  ) {
                    isMissingOptions = question.options.some(
                      (opt) => !opt?.key || !opt?.value,
                    );
                  }
                  if (Array.isArray(question.correct_answers)) {
                    isMissingOptions =
                      isMissingOptions ||
                      question.correct_answers.some(
                        (ans) =>
                          question?.options?.length > 0 &&
                          (!ans?.option_key || ans.option_key.trim() === ""),
                      );
                  }
                }
                const isReady = !isMissingBasic && !isMissingOptions;
                const isExpanded = activeQuestions.includes(index);

                return (
                  <div
                    key={index}
                    ref={(el) => (questionRefs.current[index] = el)}
                    className="question-item"
                    style={{
                      border: isExpanded
                        ? "1.5px solid #F28C28"
                        : "1px solid #E5E7EB",
                      borderRadius: "10px",
                      backgroundColor: isExpanded ? "#FFF7ED" : "#fff",
                      transition: "all 0.2s ease",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      onClick={() => toggleQuestion(index)}
                      className="d-flex align-items-center justify-content-between"
                      style={{ padding: "12px 16px", cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "36px",
                            height: "36px",
                            backgroundColor: "#FFF1E6",
                            color: "#F28C28",
                            borderRadius: "8px",
                            fontWeight: 700,
                            fontSize: "14px",
                            flexShrink: 0,
                          }}
                        >
                          Q{index + 1}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#111827",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {question.title || "Untitled Question"}
                          </div>
                          <div
                            className="d-flex align-items-center gap-2"
                            style={{
                              fontSize: "12px",
                              color: "#6B7280",
                              marginTop: "2px",
                            }}
                          >
                            <span>
                              {questionType?.find(
                                (t) => t.id === question.type_id,
                              )?.name || "No type"}
                            </span>
                            <span>•</span>
                            <span>{question.correct_score || 0} marks</span>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        {isReady ? (
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#059669",
                              backgroundColor: "#D1FAE5",
                              padding: "3px 8px",
                              borderRadius: "10px",
                              fontWeight: 500,
                            }}
                          >
                            Ready
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#C2410C",
                              backgroundColor: "#FFF7ED",
                              padding: "3px 8px",
                              borderRadius: "10px",
                              fontWeight: 600,
                              border: "1px solid #F28C28",
                            }}
                          >
                            Need attention
                          </span>
                        )}

                        <button
                          onClick={(e) => handleDeleteClick(index, e)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#FEE2E2")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                          title="Delete Question"
                        >
                          <Trash2 size={16} color="#DC2626" />
                        </button>

                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6B7280"
                          strokeWidth="2"
                          style={{
                            transform: isExpanded
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                        >
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </div>
                    </div>

                    {isExpanded && (
                      <div
                        style={{
                          padding: "0 16px 16px 16px",
                          borderTop: "1px solid #F3F4F6",
                        }}
                      >
                        <div style={{ paddingTop: "16px" }}>
                          <DefaultQuestion
                            key={index}
                            nextQuestion={index}
                            question={question}
                            setQuestions={setQuestions}
                            assessmentDetails={assessmentDetails}
                            componentType={componentType}
                            qArr={questions}
                            showErrorInputField={showErrorInputField}
                            setShowErrorInputField={setShowErrorInputField}
                            getErrorMsg={getErrorMsg}
                            isChecked={isChecked}
                            selectedBox={selectedBox}
                            isActive={true}
                            chapter={chapters}
                            questionType={questionType}
                            hasDescriptiveAutoAssessment={true}
                            onToggle={() => {}}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div
                className="text-center"
                style={{
                  padding: "30px 20px",
                  color: "#9CA3AF",
                  fontSize: "13px",
                  border: "1px dashed #D1D5DB",
                  borderRadius: "10px",
                }}
              >
                No questions yet. Add your first question above.
              </div>
            )}

            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-2"
              style={{
                marginTop: "12px",
                padding: "12px 16px",
                backgroundColor: "#F9FAFB",
                borderRadius: "10px",
                border: "1px dashed #D1D5DB",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  checked={copyPrevSettings}
                  onChange={(e) => setCopyPrevSettings(e.target.checked)}
                  style={{
                    accentColor: "#F28C28",
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: "13px", color: "#4B5563" }}>
                  Copy previous settings
                </span>
              </div>
              <button
                id="Add-options-btn"
                type="button"
                onClick={addMoreQuestion}
                className="d-flex align-items-center gap-2 rounded-3 poppins-semibold"
                style={{
                  padding: "8px 16px",
                  border: "1px solid #F28C28",
                  color: "#C2410C",
                  backgroundColor: "#FFF7ED",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                <img
                  src="/images/add button.svg"
                  alt=""
                  style={{ width: 14 }}
                />{" "}
                Add Another Question
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ========================================== */}
      {/* 4. MODALS & POPUPS — QB vs Assessment */}
      {/* ========================================== */}

      {/* 👈 Assessment / Homework → QuestionListAssessment */}
      {!isQuestionBank && click && (
        <QuestionListAssessment
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          name={name}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          operationType={OperationType.UPDATE}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}

      {/* 👈 Question Bank → PublishPreviewQB */}
      {isQuestionBank && open && (
        <PublishPreviewQB
          setPreview={setOpen}
          displayQuestions={questions}
          details={assessmentDetails}
          selectedBox={selectedBox}
          hasDescriptiveAutoAssessment={true}
          type="edit"
          onSave={() => {
            setOpen(false);
            handleCreateAssessment({ isDraft: false });
          }}
        />
      )}

      {click1 && (
        <SelectFromLibr
          setClick1={setClick1}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          getquestiondata={getquestiondata}
          operationType={operationType}
          selectedBox={selectedBox}
        />
      )}

      {isloading && (
        <div className="publish_transprant_body1">
          {isloading && (
            <div className=" p-4 publish_white_containerPre d-flex justify-content-center align-items-center">
              <img className="" width="150" src="/gif/LoaderDot.gif" alt="" />
            </div>
          )}
        </div>
      )}

      {/* DELETE DIALOG */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", padding: "8px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            fontWeight: 700,
            color: "#111827",
            pb: 1,
          }}
        >
          <div
            style={{
              backgroundColor: "#FEE2E2",
              color: "#DC2626",
              borderRadius: "50%",
              padding: "8px",
            }}
          >
            <WarningAmber fontSize="small" />
          </div>
          Delete Question?
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ color: "#4B5563", fontSize: "14px" }}
          >
            Are you sure you want to delete{" "}
            <b>Q{(questionToDelete ?? 0) + 1}</b>? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: 1 }}>
          <Button
            onClick={() => setDeleteConfirmOpen(false)}
            variant="outlined"
            sx={{
              color: "#4B5563",
              borderColor: "#D1D5DB",
              borderRadius: "8px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteQuestion}
            variant="contained"
            sx={{ backgroundColor: "#DC2626", borderRadius: "8px" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {openQuestionBox && (
        <AiGenerateQuestions
          setClick1={setClick1}
          setOpenQuestionBox={setOpenQuestionBox}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={SourceLibrary.FROM_AI_LIBRARY}
          componentType={componentType}
          getquestiondata={getquestiondata}
        />
      )}

      {newQuestionPaperMaper && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ background: "rgba(0,0,0,0.3)", zIndex: 9998 }}
          />
          <QuestionPaperMapper
            onClose={() => setNewQuestionPaperMaper(false)}
            selectedBox={selectedBox}
            componentType={componentType}
            onSaveSubmit={(mapperData) => {
              handleMapperSave(mapperData);
              setNewQuestionPaperMaper(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default UpdateQuestions;

// Library Button Component
export const LibraryButton = ({
  title,
  subtitle,
  img,
  onClick,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`btn d-flex align-items-center gap-2 px-3 py-2 w-100 ${className}`}
      style={{
        backgroundColor: "#FEF3C7",
        borderRadius: "10px",
        border: "1px solid #FDE68A",
        transition: "all 0.2s ease",
        height: "52px",
        padding: "8px 12px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#FDE68A";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(242, 140, 40, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#FEF3C7";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <AddCircleOutlineIcon
        sx={{ fontSize: 20, color: "#C2410C", flexShrink: 0 }}
      />
      <div
        className="d-flex flex-column text-start"
        style={{ flex: 1, minWidth: 0 }}
      >
        <span
          className="poppins-semibold"
          style={{
            fontSize: "14px",
            color: "#1F2937",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.2,
          }}
        >
          {title}
        </span>
        <span
          className="text-muted"
          style={{
            fontSize: "11px",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {subtitle}
        </span>
      </div>
      <img
        src={img}
        alt=""
        style={{
          width: "28px",
          height: "28px",
          objectFit: "contain",
          flexShrink: 0,
        }}
      />
    </button>
  );
};
